export const countryCode = (country: string) => {
  switch (country) {
    case 'es':
      return 'es'
    case 'pt':
      return 'pt'
    default:
      return 'global'
  }
}
